<template>
    <el-container  style="display: block;background-color: #fff;margin-left: 6%;overflow: hidden;">
      <el-row style="color: #fff;">
        <el-row :span="2" style="margin-top: 30px;color: #000;">
            名称:<el-input v-model="addname" style="width: 350px;" placeholder="请输入名称"></el-input>
        </el-row>        
        <el-row :span="2" style="margin-top: 30px;color: #000;">
            角标位置:<el-select v-model="values"  filterable placeholder="请选择">
					  <el-option
						v-for="item in options"
						:key="item"
						:label="item"

						:value="item">
					  </el-option>
					</el-select>
        </el-row>        
        <el-row :span="2" style="margin-top: 30px;color: #000;">
            图片链接:<el-input v-model="mediaUrl" style="width: 350px;" placeholder="请输入链接"></el-input>
        </el-row>        
        <div style="margin-top: 15px;">
            <el-upload
            class="upload-demo"
            action="http://centertest.yoooooo.com/upload_image"
            :show-file-list="true"
            :file-list="fileList" 
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            list-type="picture-card"
            name="file"
            :before-upload="beforeUpload"
            accept=".jpg,.jpeg,.png,.webp"
                       
            :auto-upload="true"
            >
            <i class="el-icon-plus"></i>
            <!-- <el-button type="primary" style="background-color: #409eff;">点击上传图片</el-button> -->
            </el-upload>
            
            
        </div>
       <el-button type="primary" style="background-color: #409eff;margin-top: 20px;" @click="add()">添加</el-button>
      </el-row>
      <el-row  style="margin-top: 30px;">
        <template>
          <el-table
        	:data="list"
            height="1000"
        	border
        	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
          <el-table-column
      
            width="300"
            label="名称"
             >
             <template slot-scope="scope">
                 <div @click="dischange(scope.row.name,scope.row.id,1)">{{scope.row.name}}</div>
             </template>
          </el-table-column>
          <el-table-column
      
            width="400"
            label="角标"
             >
             <template slot-scope="scope">
                 <div @click="dischange(scope.row.jiaobiao,scope.row.id,2)">{{scope.row.jiaobiao}}</div>
             </template>
          </el-table-column>
          <el-table-column
      
            width="600"
            label="图片"
             >
             <template slot-scope="scope">
                 <div v-for="item in scope.row.img" style="display: inline;">
					 <img :src="item" style="width: 80px;"/>
				 </div>
             </template>
          </el-table-column>
          
      
          <el-table-column
      
            width="200"
            label="操作"
             >
             <template slot-scope="scope">
               <el-row>
                 <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id)">删除</el-col>
				 <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="copy(scope.row.id)">复制</el-col>
      
               </el-row>
             </template>
          </el-table-column>
          </el-table>
        </template>
        <div class="page">
        	<el-pagination
        	  @size-change="loadList()"
        	  @current-change="loadList()"
        	  :current-page.sync="page"
        	  :page-size="15"
        	  background
        	  layout="total,prev, pager, next, jumper"
        	  :total="count">
        	</el-pagination>
        </div>
      </el-row>
      <el-dialog
        title="修改"
        :visible.sync="disDialogVisible"
        width="30%"
        center>
        <span>修改内容：</span>
        <input type="text" style="width: 50%;height: 30px;padding-left: 5px;"  v-model="names"/>
        
        <span slot="footer" class="dialog-footer">
        <el-button @click="disDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dodisChange()">确 定</el-button>
        </span>
    </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <span>确认删除？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="doDell()">确 定</el-button>
        </span>
      </el-dialog>
      
    </el-container>
  </template>
  
  <script>
    import { ref } from 'vue'
    
    export default {
      data() {
         return {
		  page:1,
		  count:0,	 
		  values:'左上角',
		  options:['左上角','左下角','右上角','右下角'],	 
		  list:[],
          appid:window.localStorage.getItem('appid'), 
          basename:window.localStorage.getItem('base'),  
          addname:'',
          name:'',
          mediaUrl:'',
		  disDialogVisible:false,
		  dialogVisible:false,
          fileList:[],
          fileList1:[],
          fields:[],       
          formData: {},  
                 
          screenWidth : window.innerWidth,
          screenHeight : window.innerHeight,
          
          
          
          names:'',
          
            
  
        }
      },
      directives: {
      },
      created() {
         
        this.loadList();
      //   alert(window.localStorage.getItem('base'))
      },
  
      methods:{
        
        
        handleSuccess(response, file) {
        if (response.success) {
            this.fileList.push({
                name: file.name,
                url: response.url
            })
            this.mediaUrl = this.fileList[0].url
        } else {
            this.$message.error('上传失败')
        }
        },
        handleRemove(file, fileList) {
        // 这里只做前端删除fileList里的数据，不调用后端接口
            this.fileList = fileList
            if(this.fileList.length > 0){
                this.mediaUrl = this.fileList[0].url
            }else{
                this.mediaUrl = ''
            }
            this.$message.info(`已删除文件：${file.name}`)
        },
        clearUpload1() {
            this.fileList1 = []
            this.mediaUrl1 = ''
        },        
        handleSuccess1(response, file) {
            this.mediaUrl1 = response.url
            this.fileList1 = [file]
            console.log('✅ 上传成功', response)
        },
        handleError(err, file) {
            console.error('❌ 上传失败', err)
        },
        isImage(url) {
            return /\.(jpg|jpeg|png|webp|gif)$/i.test(url)
        },
        isNumber(val) {
            return /^[+-]?\d+(\.\d+)?$/.test(val.trim())
        },
        beforeUpload(file) {
            
            const isValidType = [
                'image/jpeg',
                'image/jpg',
                'image/png',
				'image/gif',
                'image/webp',
                
            ].includes(file.type)

            const isLt100M = file.size / 1024 / 1024 < 100

            if (!isValidType) {
                ElMessage.error('仅支持图片式')
            }
            if (!isLt100M) {
                ElMessage.error('文件不能超过 100MB')
            }

            return isValidType && isLt100M
        },
        dischange(name,id,t){
          this.t = t;
          this.changeId = id
          this.names = name
          this.disDialogVisible = true
        },
        dodisChange(){
          const axiosInstance = this.$axios.create({
          	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
          	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
          });
          axiosInstance({
          	method:'post',
          	params:{
              id:this.changeId,
              name:this.names,
              t:this.t
          	},
          	url:'http://y31p.yoooooo.com/index.php/index/data/jiaobiaoChanges'
          })
          .then(res=>{
            console.log(res.data.code)
            if(res.data.code == 200){
              this.disDialogVisible = false
              this.loadList()
            }else{
              this.msg('名称重复','error');
              this.disDialogVisible = false
        
            }
        
        
        
          })
          .catch(err=>{
        
          });
        },
          loadList(){
            const axiosInstance = this.$axios.create({
              headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
              withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
            });
            axiosInstance({
              method:'post',
              data:{
                p:this.page,
                
                
              },
              url:'http://y31p.yoooooo.com/index.php/index/data/jiaobiaoList'
            })
            .then(res=>{
              this.list = res.data.data
			  this.count = 	res.data.count
            })
            .catch(err=>{
  
            });
          }, 
          del(id){
            const axiosInstance = this.$axios.create({
            	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
            	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
            });
          
            
            axiosInstance({
            	method:'post',
            	params:{
            		id:id,
            	},
            	url:'http://y31p.yoooooo.com/index.php/index/data/jiaobiaoDel'
            })
            .then(res=>{
            	if(res.data.code == 200){
          
                 this.$message({
                 	type: 'success',
                 	message: '操作成功'
                 });
                 this.loadList();
            	}else{
          
            	}
          
            })
            .catch(err=>{
          
            });
          },
		  copy(id){
		    const axiosInstance = this.$axios.create({
		    	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
		    	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
		    });
		  
		    
		    axiosInstance({
		    	method:'post',
		    	params:{
		    		id:id,
		    	},
		    	url:'http://y31p.yoooooo.com/index.php/index/data/jiaobiaoCopy'
		    })
		    .then(res=>{
		    	if(res.data.code == 200){
		  
		         this.$message({
		         	type: 'success',
		         	message: '操作成功'
		         });
		         this.loadList();
		    	}else{
		  
		    	}
		  
		    })
		    .catch(err=>{
		  
		    });
		  },
          add(){
            const axiosInstance = this.$axios.create({
              headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
              withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
            });
            if(this.addname == ''){
              this.msg('请填写名称','error')
              return false
            }
            if(this.mediaUrl == ''){
              this.msg('请上传图片','error')
              return false
            }
            
            
            const imgs = this.fileList.map(item => item.url).join(';')
                   
            axiosInstance({
              method:'post',
              url:'http://y31p.yoooooo.com/index.php/index/data/jiaobiaoAdd',
              data:{
                  name:this.addname,
                  jiaobiao:this.values,                   
                  imgs:imgs,                 
                  
              }
            })
            .then(res=>{			
              this.addname = ''
              this.mediaUrl = ''
              
              this.fileList = []        
              this.clearUpload1()
              this.$message({
                  type: 'success',
                  message: '添加成功'
                 });
              this.loadList()
            })
            .catch(err=>{
  
            });
          },
          msg(msg,type){
              this.$message({
                message: msg,
                type: type
              });
          },
  
      }
  
  
    }
  </script>
  
  <style>
  
  body{
      background-color: #fff;
      font-family: hanyi;
  }
  .el-scrollbar__bar{
      overflow: hidden;
  }
  
  
 
  
  
  </style>
  


// WEBPACK FOOTER //
// src/components/main/jiaobiao.vue